import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { isClientApp } from 'ziphy-web-shared/basic/helpers';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { Title } from 'ziphy-web-shared/basic/lib/simple';
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { $appts } from '@store';
import styles from './JoinConference.modal.module.scss';
const JoinConferenceModal = ({ _core }) => {
    var _a;
    const { t } = useTranslation();
    const { fullAppt, actions = {} } = $appts.byRoute;
    const { appointment } = fullAppt;
    const isShowChat = actions.textGeneral || actions.textStaff;
    function startClient(source) {
        if (actions.startVideo) {
            if (source === 'auto' && !$windowSize.isMobileOnly) {
                actions.startVideo.restart();
                handleClose();
            }
            else {
                actions.startVideo.action({ source });
            }
        }
    }
    function textToChat(message) {
        if (actions.textGeneral) {
            actions.textGeneral.action(message);
        }
        else if (actions.textStaff) {
            actions.textStaff.action(message);
        }
    }
    function handleClose() {
        _core.onHide();
    }
    return (_jsxs(Modal, Object.assign({ centered: true, scrollable: true, onHide: () => $appts.getOne({ id: appointment.id }) }, { children: [_jsx("div", Object.assign({ className: "modal-toolbar" }, { children: _jsx(ModalToolbarBtn, { type: "close", action: _core.onHide }) })), _jsx(Modal.Header, Object.assign({ className: 'pb-0' }, { children: t('label.conference_in_progress') })), _jsxs(Modal.Body, { children: [_jsx("div", Object.assign({ className: "mb-20" }, { children: _jsx(Trans, { i18nKey: isClientApp()
                                ? 'text.join_conference.message_client'
                                : 'text.join_conference.message_staff', components: [
                                _jsx("a", { href: "https://support.zoom.us/hc/en-us/articles/206175806", target: "_blank", rel: "noreferrer" }),
                            ] }) })), _jsx(Title, Object.assign({ size: 'h3', className: 'mb-20' }, { children: t('text.join_conference.title') })), _jsxs("div", Object.assign({ className: styles.buttons }, { children: [!$windowSize.isMobileOnly && ((_a = actions.startVideo) === null || _a === void 0 ? void 0 : _a.restart) && (_jsx(Button, Object.assign({ mode: ['secondary', 'block'], onClick: () => startClient('auto') }, { children: t('btn.restart_video') }))), _jsx(Button, Object.assign({ mode: ['secondary', 'block'], onClick: () => startClient('app') }, { children: t('btn.start_in_app') })), _jsx(Button, Object.assign({ mode: ['secondary', 'block'], onClick: () => startClient('browser') }, { children: t('btn.start_in_browser') })), isShowChat && (_jsx(Button, Object.assign({ mode: ['secondary', 'block'], onClick: () => textToChat(t('text.join_conference.problem.could_not_start')) }, { children: t('text.join_conference.problem.could_not_start') }))), isShowChat && (_jsx(Button, Object.assign({ mode: ['secondary', 'block'], onClick: () => textToChat(t('text.join_conference.problem.connection')) }, { children: t('text.join_conference.problem.connection') })))] }))] }), _jsx(Modal.Footer, { children: _jsx(Button, Object.assign({ mode: ['primary', 'block'], onClick: handleClose }, { children: t('btn.we_are_done') })) })] })));
};
JoinConferenceModal.displayName = 'JoinConferenceModal';
export default observer(JoinConferenceModal);
